// src/utils/orderUtils.js

/**
 * Returns a display label and Bootstrap color for a given payment status string.
 * Used in CartPage (history tab) and ReviewPaymentsPage.
 */
export function paymentStatusLabel(status) {
  switch (status) {
    case 'PAID':
    case 'PAID_PAYPAL':   return { label: 'Pagado',       color: 'success' };
    case 'UPLOADED_RECEIPT': return { label: 'En revisión', color: 'warning' };
    case 'PAYMENT_REJECTED': return { label: 'Rechazado',  color: 'danger'  };
    case 'PENDING_PAYMENT':
    case 'PENDING':       return { label: 'Pendiente',    color: 'secondary' };
    default:              return { label: status ?? '—',  color: 'secondary' };
  }
}

/**
 * Returns true when an order object represents a successfully paid order.
 */
export function isOrderPaidStatus(order) {
  if (!order) return false;
  return (
    order.paymentStatus === 'PAID' ||
    order.paymentStatus === 'PAID_PAYPAL' ||
    !!order.downloadUrl
  );
}

/**
 * Formats an ISO date string to a human-readable Spanish locale date.
 */
export function formatOrderDate(isoString) {
  if (!isoString) return '—';
  return new Date(isoString).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
